// aws api profiles
import api from '../../aws/api/profiles/json.profile.api.aws';

const listGlobalResilienceFactorsApi = () =>
  api().get(
    `data/cache/globalResilience/output/latest/globalResilienceIndexFactors.json`
  );

export default listGlobalResilienceFactorsApi;
